import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import CycleCalculator from '../components/CycleCalculator';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const CycleCalculatorPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <div className="inline-block bg-pink-50 px-4 py-2 rounded-full mb-4">
               <Calendar className="w-5 h-5 text-[#FF6B9D] inline mr-2" />
               <span className="text-[#FF6B9D] font-medium text-sm">Smart Health Tool</span>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Cycle Calculator</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Predict your next period, ovulation, and fertile window with our AI-powered tool. 
              Knowledge is empowerment. ✨
            </p>
          </div>

          <div className="bg-white rounded-[3rem] shadow-2xl border border-pink-50 overflow-hidden p-4 md:p-10">
            <CycleCalculator />
          </div>

          <div className="mt-16 text-center">
            <p className="text-gray-500 text-sm">
              Note: This calculator provides estimates based on your input. 
              Always consult a healthcare professional for clinical advice.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CycleCalculatorPage;
